var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveFlowCreatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.701,
    height: 24,
    viewBox: "0 0 25.701 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10622",
    d: "M28 10h-4.287v1.713H28v5.14h-6v1.713h2.57V20.4a3.427 3.427 0 1 0 1.713 0v-1.833H28a1.716 1.716 0 0 0 1.713-1.713v-5.14A1.715 1.715 0 0 0 28 10zm-.86 13.707a1.713 1.713 0 1 1-1.713-1.713 1.713 1.713 0 0 1 1.713 1.713z",
    transform: "translate(-4.01 -3.147)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10623",
    d: "M18 6h-4.287v1.713H18v5.14h-6v1.713h2.57v5.262a3.427 3.427 0 1 0 1.713 0v-5.261H18a1.715 1.715 0 0 0 1.713-1.713V7.713A1.715 1.715 0 0 0 18 6zm-.86 17.134a1.713 1.713 0 1 1-1.713-1.713 1.713 1.713 0 0 1 1.713 1.713z",
    transform: "translate(-2.576 -2.573)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10624",
    d: "M7.853 2h-5.14A1.715 1.715 0 0 0 1 3.713v5.14a1.715 1.715 0 0 0 1.713 1.713h1.714v8.688a3.427 3.427 0 1 0 1.713 0v-8.687h1.713a1.715 1.715 0 0 0 1.714-1.714v-5.14A1.715 1.715 0 0 0 7.853 2zM7 22.56a1.713 1.713 0 1 1-1.713-1.713A1.713 1.713 0 0 1 7 22.56zM2.713 8.853v-5.14h5.14v5.14z",
    style: {
      fill: "#203662"
    },
    transform: "translate(-1 -2)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFlowCreatorIcon);
export default __webpack_public_path__ + "static/media/Active-Flow-Creator-Icon.7805c0cef1a8100cc7596a4d5013c8ff.svg";
export { ForwardRef as ReactComponent };